import { customizeError, formatDate } from '@chilecompra/react-kit'
import { REACT_APP_SEARCH_DETAILS_PURCHASE_ORDER_URL } from '../../config/settings/environment'
import { makeActionCreator } from '../../config/store/utils'
import { formatCurrency } from '../../modules/utils/formatters'
import { getEncryptOrderNumber } from '../../services/buyer'
import { getOutsideAnnualPurchasePlan } from '../../services/annualPurchasePlan'

export const GET_OUTSIDE_ANNUAL_PURCHASE_PLAN = 'GET_OUTSIDE_ANNUAL_PURCHASE_PLAN'
export const GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_ERROR = 'GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_ERROR'
export const GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_SUCCESS = 'GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_SUCCESS'
export const onGetOutsideAnnualPurchasePlan = makeActionCreator(GET_OUTSIDE_ANNUAL_PURCHASE_PLAN)
export const onGetOutsideAnnualPurchasePlanError = makeActionCreator(GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_ERROR, 'payload')
export const onGetOutsideAnnualPurchasePlanSuccess = makeActionCreator(
  GET_OUTSIDE_ANNUAL_PURCHASE_PLAN_SUCCESS,
  'payload'
)
export const onGetOutsideAnnualPurchasePlanThunk = payload => async dispatch => {
  dispatch(onGetOutsideAnnualPurchasePlan())

  try {
    const {
      data: { payload: response }
    } = await getOutsideAnnualPurchasePlan({
      actionType: GET_OUTSIDE_ANNUAL_PURCHASE_PLAN,
      dni: payload.dni,
      page: payload.page - 1,
      size: payload.rowsPerPage
    })
    const { data } = response
    const hasData = data.length > 0
    const year = hasData ? new Date(response.fechaActualizacionPAC + 'T00:00:00').getFullYear() : ''
    const publicationDate = hasData
      ? formatDate(new Date(response.fechaActualizacionPAC + 'T00:00:00'), 'dd-MM-yyyy')
      : null

    const gridData = data.map(item => {
      return {
        idPurchaseOrder: item.codeOC,
        id: item.idOrdenOrigin,
        amount: formatCurrency(item.monto, item.moneda),
        name: item.nombre,
        provider: item.proveedor,
        shippingDate: formatDate(new Date(item.fechaEnvioOC + 'T00:00:00'), 'dd-MM-yyyy'),
        updateDate: formatDate(new Date(item.fechaActualizacion + 'T00:00:00'), 'dd-MM-yyyy'),
        currency: item.moneda,
        status: item.estado
      }
    })

    const excelData = gridData.map(item => {
      return {
        ID: item.idPurchaseOrder,
        Monto: item.amount,
        Nombre: item.name,
        Proveedor: item.provider,
        'Fecha envío OC': item.shippingDate,
        'Estado OC': item.status
      }
    })

    const page = response.paginaActual || 1
    const records = response.totalResultados || 1
    const total = response.totalPaginas || 1

    return dispatch(
      onGetOutsideAnnualPurchasePlanSuccess({
        hasData,
        year,
        publicationDate,
        gridData,
        excelData,
        page,
        records,
        total
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetOutsideAnnualPurchasePlanError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const GET_ENCRYPT_PURCHASE_ORDER = 'GET_ENCRYPT_PURCHASE_ORDER'
export const GET_ENCRYPT_PURCHASE_ORDER_ERROR = 'GET_ENCRYPT_PURCHASE_ORDER_ERROR'
export const GET_ENCRYPT_PURCHASE_ORDER_SUCCESS = 'GET_ENCRYPT_PURCHASE_ORDER_SUCCESS'
export const onGetEncryptPurchaseOrder = makeActionCreator(GET_ENCRYPT_PURCHASE_ORDER)
export const onGetEncryptPurchaseOrderError = makeActionCreator(GET_ENCRYPT_PURCHASE_ORDER_ERROR, 'payload')
export const onGetEncryptPurchaseOrderSuccess = makeActionCreator(GET_ENCRYPT_PURCHASE_ORDER_SUCCESS, 'payload')
export const onGetEncryptPurchaseOrderThunk = payload => async dispatch => {
  dispatch(onGetEncryptPurchaseOrder())

  try {
    const { data } = await getEncryptOrderNumber({
      actionType: GET_ENCRYPT_PURCHASE_ORDER,
      orderNumber: payload.id
    })
    window.open(`${REACT_APP_SEARCH_DETAILS_PURCHASE_ORDER_URL}?qs=${data?.payload?.encrypt}`, 'Ficha_Compra')

    return dispatch(
      onGetEncryptPurchaseOrderSuccess({
        encrypt: data?.payload?.encrypt
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetEncryptPurchaseOrderError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
